import { render, staticRenderFns } from "./RingCentral.vue?vue&type=template&id=187a2738&scoped=true&"
import script from "./RingCentral.vue?vue&type=script&lang=js&"
export * from "./RingCentral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a2738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187a2738')) {
      api.createRecord('187a2738', component.options)
    } else {
      api.reload('187a2738', component.options)
    }
    module.hot.accept("./RingCentral.vue?vue&type=template&id=187a2738&scoped=true&", function () {
      api.rerender('187a2738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/Profile/RingCentral.vue"
export default component.exports